class LomiAuthClient {
    constructor() {}

    authenticate(username, password, onSuccess, onError) {
        aws_amplify.Amplify.Auth.signIn(username, password)
            .then(user => {
                aws_amplify.Amplify.Auth.currentSession()
                    .then(session => onSuccess(session))
                    .catch(err => {
                        const userErr = {
                            userErrorMessage: err,
                        }
                        onError(userErr);
                    });
            })
            .catch(err => {
                const userErr = {
                    userErrorMessage: err,
                }
                onError(userErr);
            });
    }
}
